import Config from "@/const/Config";
import { SyuugyouBasyo, SyuugyouBasyoAndKoyouKeiyaku, SyuugyouBasyoAndKoyouKeiyakuOption, SyuugyouBasyoOption, SyuugyouBasyoReq } from "@/types/SyuugyouBasyo";
import { BaseApi } from "@/api/BaseApi";
import { BaseOptionWithoutCode } from "@/types/Option";
import { DeleteSyuugyouBasyoRes, SyuugyouBasyo as MstSyuugyouBasyo, UpsertSyuugyouBasyoRes } from "@/types/KoyouKeiyaku";

export class SyuugyouBasyoApi extends BaseApi {
  /**
   * 全就業場所一覧を取得します
   * @returns システム上の全ての就業場所一覧
   */
  public async getAll(): Promise<SyuugyouBasyo[]> {
    try {
      const res = await this.post<SyuugyouBasyo[]>(Config.API_URL + '/syuugyou_basyo/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * マスタに登録されている就業場所のうち、実行ユーザーに閲覧権限のある就業場所を取得します（オプション値）
   */
  public async getAllOptions(): Promise<SyuugyouBasyoOption[]> {
    try {
      const res = await this.post<SyuugyouBasyoOption[]>(Config.API_URL + '/syuugyou_basyo/options/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }


  /**
   * 指定したユーザーの有効な雇用契約に基づき就業場所を取得します
   */
  public async getByUserId(req: SyuugyouBasyoReq): Promise<SyuugyouBasyo[]> {
    try {
      const res = await this.post<SyuugyouBasyo[]>(Config.API_URL + '/syuugyou_basyo/user', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定ユーザーの就業場所を取得します（オプション値）
   * @returns 当該ユーザーの就業場所一覧
   */
  public async getOptionsByUserId(req: SyuugyouBasyoReq): Promise<SyuugyouBasyoOption[]> {
    try {
      const res = await this.post<SyuugyouBasyoOption[]>(Config.API_URL + '/syuugyou_basyo/options/user', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 特定ユーザの有効な雇用契約と期間内の打刻に基づく就業場所を取得します
   * @returns 当該ユーザーの就業場所一覧
   */
  public async getByDakokuAndKoyouKeiyaku(req: SyuugyouBasyoReq): Promise<SyuugyouBasyo[]> {
    try {
      const res = await this.post<SyuugyouBasyo[]>(Config.API_URL + '/syuugyou_basyo/dakoku_and_koyou_keiyaku', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定したユーザーの有効な雇用契約と打刻履歴に基づき就業場所を取得します（オプション値）
   */
  public async getOptionsByDakokuAndKoyouKeiyaku(req: SyuugyouBasyoReq): Promise<SyuugyouBasyoOption[]> {
    try {
      const res = await this.post<SyuugyouBasyoOption[]>(Config.API_URL + '/syuugyou_basyo/options/dakoku_and_koyou_keiyaku', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   *  指定ユーザーの有効な雇用契約に基づく就業場所一覧とその雇用契約で定められた就業時間を取得します
   */
  public async getByUserIdWithKoyouKeiyakuTimes(req: SyuugyouBasyoReq): Promise<SyuugyouBasyoAndKoyouKeiyaku[]> {
    try {
      const res = await this.post<SyuugyouBasyoAndKoyouKeiyaku[]>(Config.API_URL + '/syuugyou_basyo/with_koyou_keiyaku', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   *  指定ユーザーの有効な雇用契約に基づく就業場所一覧とその雇用契約で定められた就業時間を取得します（オプション値）
   */
  public async getOptionByUserIdWithKoyouKeiyakuTimes(req: SyuugyouBasyoReq): Promise<SyuugyouBasyoAndKoyouKeiyakuOption[]> {
    try {
      const res = await this.post<SyuugyouBasyoAndKoyouKeiyakuOption[]>(Config.API_URL + '/syuugyou_basyo/options/with_koyou_keiyaku', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 部課に属していない就業場所一覧を取得します
   */
  public async getNoBelongToBuka(): Promise<SyuugyouBasyo[]> {
    try {
      const res = await this.post<SyuugyouBasyo[]>(Config.API_URL + '/master/syuugyou_basyo/no_belong', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 部課に属していない就業場所一覧を取得します（オプション値）
   */
  public async getNoBelongToBukaOptions(): Promise<BaseOptionWithoutCode[]> {
    try {
      const res = await this.post<BaseOptionWithoutCode[]>(Config.API_URL + '/master/syuugyou_basyo/options/no_belong', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 就業場所の新規作成／更新
   */
  public async upsert(syuugyouBasyo: MstSyuugyouBasyo) {
    try {
      const res = await this.post<UpsertSyuugyouBasyoRes>(Config.API_URL + '/master/syuugyou_basyo/upsert', syuugyouBasyo);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 就業場所の新規作成／更新
   */
  public async deleteSyuugyouBasyo(syuugyouBasyoId: number) {
    try {
      const res = await this.post<DeleteSyuugyouBasyoRes>(Config.API_URL + '/master/syuugyou_basyo/delete', { syuugyouBasyoId: syuugyouBasyoId });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }
}
